import type { FC, ChangeEvent } from 'react';
import type { UseFormSetValue } from 'react-hook-form';

import { useState, useCallback } from 'react';

import { Field } from 'src/components/hook-form';

// ==================== Types ====================
interface LiveChatConfig {
  widgetColor?: string;
}

interface SelectedChannel {
  LiveChatConfig?: LiveChatConfig[];
}

interface LiveChatFieldsProps {
  t: (key: string) => string;
  selectedChannel?: any;
  setValue: UseFormSetValue<any>;
}

// ==================== Constants ====================
const DEFAULT_WIDGET_COLOR = '#2563eb';

// ==================== Component ====================
export const LiveChatFields: FC<LiveChatFieldsProps> = ({ t, selectedChannel, setValue }) => {
  const [color, setColor] = useState<string>(
    selectedChannel?.config?.settings?.widgetColor || DEFAULT_WIDGET_COLOR
    );

  const handleColorChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const newColor = e.target.value || DEFAULT_WIDGET_COLOR;
      setColor(newColor);
      setValue('widgetColor', newColor);
    },
    [setValue]
  );

  return (
    <>
      <Field.Text
        name="websiteDomin"
        label={t('WEB_DOMAIN')}
        placeholder={t('ENTER_WEBSITE_DOMAIN')}
        fullWidth
      />
      <Field.Text
        name="widgetColor"
        label={t('WIDGET_COLOR')}
        sx={{ width: '30%' }}
        slotProps={{ inputLabel: { shrink: true } }}
        type="color"
        value={color}
        onChange={handleColorChange}
      />
      <Field.Text
        name="welcomeTitle"
        label={t('WELL_HEADING')}
        placeholder={t('ENTER_WELCOME_TITLE')}
        fullWidth
      />
      <Field.Text
        name="welcomeTagline"
        label={t('WELL_TAGLINE')}
        placeholder={t('ENTER_WELCOME_TAGLINE')}
        fullWidth
        multiline
        rows={3}
      />
    </>
  );
};
